/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connect } from 'react-redux';
export default connect(
  (state) => ({
    globalHeader: state.globalHeader
  }),
  (dispatch) => {
    return {
      showMobileSearch(show) {
        dispatch({
          type: '@@globalHeader/SHOW_MOBILE_SEARCH',
          show,
        });
      },
      setSearchBoxValue: (value) => {
        dispatch({
          type: '@@globalHeader/SET_SEARCH_BOX_VALUE',
          value,
        });
      }
    };
  }
);
